import type { SVGProps } from 'react';

const SvgHelpCenterAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 15" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M7 5.064c-.598 0-1 .44-1 .886H4.666c0-1.27 1.09-2.22 2.334-2.22s2.333.95 2.333 2.22c0 .502-.082.97-.464 1.367-.313.325-.792.55-1.31.79l-.005.003c-.1.047-.152.071-.194.095l-.012.008a1 1 0 0 0-.015.184v.667H6v-.667c0-.39.075-.755.327-1.049.202-.235.477-.36.63-.43l.039-.019c.593-.276.808-.399.912-.507l.003-.002c.034-.036.089-.092.089-.44 0-.446-.403-.886-1-.886m.355 3.127-.002.006z"
      clipRule="evenodd"
    />
    <path fill={props.color} d="M7.333 10.397a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0" />
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M7 .73a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 7 .73M1.666 7.397a5.333 5.333 0 1 1 10.667 0 5.333 5.333 0 0 1-10.667 0"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgHelpCenterAlt;
